import React, { useState } from "react";
import styles from "./section.module.css";
import {
  FaPlus,
  FaMinus,
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle,
} from "react-icons/fa";
import VideoWithCaptions from "../WizardComponents/videoWithCaptions";

const Section = ({
  title,
  videoNote,
  correct,
  incorrect,
  tips,
  videoSrcCorrect,
  posterCorrect,
  videoSrcIncorrect,
  posterIncorrect,
  imageListCorrect,
  imageListIncorrect,
  part,
}) => {
  const [open, setOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);

  return (
    <div className={styles.section}>
      <button className={styles.sectionToggle} onClick={() => setOpen(!open)}>
        <h3 className={styles.sectionTitle}>{title}</h3>
        <span>{open ? <FaMinus size="24px" /> : <FaPlus size="24px" />}</span>
      </button>

      {open && (
        <div className={styles.sectionContent}>
          {videoNote && <p className={styles.videoNote}>🎥 {videoNote}</p>}

          <div className={styles.comparison}>
            <div>
              <h4>
                <FaCheckCircle size="24px" color="green" /> Correct Fit
              </h4>
              <ul>
                {correct.map((correct, idx) => (
                  <li key={idx}>{correct}</li>
                ))}
              </ul>
              {videoSrcCorrect && (
                <VideoWithCaptions
                  videoSource={videoSrcCorrect}
                  videoPoster={posterCorrect}
                  part={`${part}Correct`}
                />
              )}

              {imageListCorrect?.length > 0 && (
                <div className={styles.imageList}>
                  {imageListCorrect.map((item, idx) => (
                    <div
                      key={idx}
                      className={styles.imageWrapper}
                      onClick={() => setLightboxImage(item)}
                    >
                      <img
                        src={
                          require(`../../../assets/recommended/${item.src}`)
                            .default
                        }
                        alt={item.caption || `Correct fit example ${idx + 1}`}
                      />
                      {item.caption && (
                        <p className={styles.imageCaption}>{item.caption}</p>
                      )}
                    </div>
                  ))}

                  {lightboxImage && (
                    <div
                      className={styles.lightbox}
                      onClick={() => setLightboxImage(null)}
                    >
                      <div className={styles.lightboxContent}>
                        <img
                          src={
                            require(`../../../assets/recommended/${lightboxImage.src}`)
                              .default
                          }
                          alt={lightboxImage.caption || "Enlarged view"}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div>
              <h4>
                <FaTimesCircle size="24px" color="red" /> Incorrect Fit
              </h4>
              <ul>
                {incorrect.map((incorrect, idx) => (
                  <li key={idx}>{incorrect}</li>
                ))}
              </ul>
              {videoSrcIncorrect && (
                <VideoWithCaptions
                  videoSource={videoSrcIncorrect}
                  videoPoster={posterIncorrect}
                  part={`${part}Incorrect`}
                />
              )}

              {imageListIncorrect?.length > 0 && (
                <div className={styles.imageList}>
                  {imageListIncorrect.map((item, idx) => (
                    <div
                      key={idx}
                      className={styles.imageWrapper}
                      onClick={() => setLightboxImage(item)}
                    >
                      <img
                        src={
                          require(`../../../assets/recommended/${item.src}`)
                            .default
                        }
                        alt={item.caption || `Incorrect fit example ${idx + 1}`}
                      />
                      {item.caption && (
                        <p className={styles.imageCaption}>{item.caption}</p>
                      )}
                    </div>
                  ))}

                  {lightboxImage && (
                    <div
                      className={styles.lightbox}
                      onClick={() => setLightboxImage(null)}
                    >
                      <div className={styles.lightboxContent}>
                        <img
                          src={
                            require(`../../../assets/recommended/${lightboxImage.src}`)
                              .default
                          }
                          alt={lightboxImage.caption || "Enlarged view"}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {tips && (
            <div className={styles.tips}>
              <h4>
                <FaInfoCircle size="24px" /> Tips:
              </h4>
              <ul>
                {tips.map((tip, idx) => (
                  <li key={idx}>{tip}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Section;
